<template>
    <div class="calendar" v-loading="loading">
        <div class="calendar-header">
            <div class="date">{{day.year()}}年 {{day.month() + 1}}月<span style="display: none">{{cnt}}</span></div>
            <div class="buttons">
                <span class="today-button cursor-pointer" @click="setToday">今日</span>
                <span class="prev-button cursor-pointer" @click="prev">
                    <img src="../assets/icon/arrow-left-circle.png" alt="">
                </span>
                <span class="next-button cursor-pointer" @click="next">
                    <img src="../assets/icon/arrow-right-circle.png" alt="">
                </span>
            </div>
        </div>
        <div class="calendar-body">
            <div>
                <span
                   v-for="(day, index) in dayOfWeekText"
                   :key="index"
                   class="date-cell cursor-pointer">{{day}}
                </span>
            </div>
            <div v-for="(week, index) in weeks" :key="index">
                <div>
                   <span v-for="(day, index2) in week"
                         :key="index2"
                         class="date-cell cursor-pointer"
                         @click="selectDay(day.day, index)"
                         :class="{'date-not-available': !day.is_able_select, 'not-in-current-month': !isCurrentMonth(day.day, index), 'today': isToday(day.day), 'is-selected': checkSelectedDay(day, index)}">
                       {{`${day.day}`}}
                       <span v-if="isAbleSelect(day)"></span>
                   </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import CalendarApi from '@/api/calendar'
import {apiErrorDialog} from '@/helpers'

export default {
  props: {
    autoSetToday: {type: Boolean, required: false, default: false},
    todayText: {type: String, required: false, default: 'Today'},
    nextText: {type: String, required: false, default: 'Next'},
    prevText: {type: String, required: false, default: 'Prev'},
    pharmacy: {type: Object, default: () => { return {} }},
    meeting: {type: Object, default: () => { return {} }},
    initDate: {type: Object, default: () => { return moment() }}
  },
  data () {
    return {
      dayOfWeekText: ['日', '月', '火', '水', '木', '金', '土'],
      cnt: 0,
      day: moment(),
      today: moment(),
      selectedDay: null,
      weeks: [],
      calendars: [],
      loading: false
    }
  },
  methods: {
    checkSelectedDay (day, index) {
      if (this.$route.name === 'meetings.edit') {
        return (
          moment(this.meeting.start_at).year() === day.year &&
          moment(this.meeting.start_at).month() + 1 === day.month &&
          moment(this.meeting.start_at).date() === day.day
        )
      }
      return this.isCurrentMonth(day.day, index) && this.isSelectedDay(day.day)
    },
    setToday () {
      this.weeks = []
      this.day = moment()
      this.cnt = 0
      const firtWeekDays = this.getFirtWeekDays()
      const lastWeekDays = this.getLastWeekDays()
      this.weeks = this.getWeekDays(firtWeekDays, lastWeekDays)
      this.selectDay(moment().date())
    },
    prev () {
      this.weeks = []
      this.day = this.day.subtract(1, 'M')
      this.cnt++
      this.fetchData()
    },
    next () {
      this.weeks = []
      this.day = this.day.add(1, 'M')
      this.cnt++
      this.fetchData()
    },
    getFirtWeekDays () {
      const todayCopy = _.cloneDeep(this.day)
      this.selectedMonth = moment().month() + 1
      const startOfMonth = todayCopy.startOf('month')
      const endOfPrevMonth = todayCopy.subtract(1, 'M').endOf('month')
      let week = []
      if (endOfPrevMonth.day() !== 6) {
        for (let i = 0; i < startOfMonth.day() + 1; i++) {
          const day = endOfPrevMonth.date() - i
          const month = endOfPrevMonth.month() + 1
          const year = endOfPrevMonth.year()
          week.push({
            day: day,
            month: month,
            year: year,
            is_able_select: this.checkIsAbleSelect(day, month, year)
          })
        }
        week.reverse()
        const end = 6 - startOfMonth.day()
        for (let i = 0; i < end; i++) {
          const day = i + 1
          const month = endOfPrevMonth.add(1, 'day').month() + 1
          const year = startOfMonth.add(1, 'day').year()
          week.push({
            day: day,
            month: month,
            year: year,
            is_able_select: this.checkIsAbleSelect(day, month, year)
          })
        }
      }
      return week
    },
    getLastWeekDays () {
      const todayCopy = _.cloneDeep(this.day)
      const endOfMonth = todayCopy.endOf('month')
      let week = []
      for (let i = 0; i < endOfMonth.day() + 1; i++) {
        const day = endOfMonth.date() - i
        const month = endOfMonth.month() + 1
        const year = endOfMonth.year()
        week.push({
          day: day,
          month: month,
          year: year,
          is_able_select: this.checkIsAbleSelect(day, month, year)
        })
      }
      week.reverse()
      const end = 6 - endOfMonth.day()
      for (let i = 0; i < end; i++) {
        const day = i + 1
        const month = endOfMonth.month() + 2 > 12 ? 1 : endOfMonth.month() + 2
        const year = moment(endOfMonth.format('YYYY-MM-DD')).add(1, 'day').year()
        week.push({
          day: day,
          month: month,
          year: year,
          is_able_select: this.checkIsAbleSelect(day, month, year)
        })
      }
      return week
    },
    getWeekDays (firtWeekDays, lastWeekDays) {
      const start = firtWeekDays.length === 0 ? 0 : firtWeekDays[6]
      const end = lastWeekDays.length === 0 ? moment().endOf('month').date() + 1 : lastWeekDays[0]
      let weeks = []
      let week = []
      let i = start !== 0 ? start.day : 0
      for (i = i + 1; i < end.day; i++) {
        const day = i
        const month = start !== 0 ? start.month : end.month
        const year = start !== 0 ? start.year : end.year
        week = [...week, {
          day: day,
          month: month,
          year: year,
          is_able_select: this.checkIsAbleSelect(day, month, year)
        }]
        if (week.length === 7) {
          weeks = [...weeks, week]
          week = []
        }
      }
      return [firtWeekDays, ...weeks, lastWeekDays]
    },
    checkIsAbleSelect (day, month, year) {
      const dateAvailable = moment(`${year}-${month}-${day}`).format('YYYY-MM-DD')
      const index = _.findIndex(this.calendars, n => n.date === dateAvailable && moment(n.date).isAfter(moment().subtract(1, 'day')))
      if (index !== -1) return true
      return false
    },
    isCurrentMonth (day, weekIndex) {
      if (weekIndex === 0 && day > 7) return false
      if (weekIndex > 1 && day <= 7) return false
      return true
    },
    isToday (day) {
      return (this.today.year() === this.day.year() && this.today.month() === this.day.month() && this.today.date() === day)
    },
    isSelectedDay (day) {
      return (this.selectedDay &&
        this.selectedDay.year() === this.day.year() &&
        this.selectedDay.month() === this.day.month() &&
        this.selectedDay.date() === day)
    },
    async isAbleSelect (day) {
    },
    selectDay (day, weekIndex = null) {
      if (weekIndex === 0 && day > 7) {
        this.prev()
        this.selectDay(day)
      } else if (weekIndex > 1 && day <= 7) {
        this.next()
        this.selectDay(day)
      } else {
        this.selectedDay = _.cloneDeep(this.day)
        this.selectedDay.date(day)
        this.$emit('dateChanged', this.selectedDay)
      }
    },
    async handleData () {
      const start = this.day.startOf('month').format('YYYY-MM-DD 00:00:00')
      const end = this.day.endOf('month').format('YYYY-MM-DD 23:59:59')
      const calendarRes = await CalendarApi.getByPharmacyId({ start: start, end: end }, this.pharmacy.id)
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      this.calendars = calendarRes.data.data
    },
    async fetchData () {
      this.loading = true
      await this.handleData()
      const firtWeekDays = this.getFirtWeekDays()
      const lastWeekDays = this.getLastWeekDays()
      this.weeks = this.getWeekDays(firtWeekDays, lastWeekDays)
      setTimeout(() => { this.loading = false }, 500)
    }
  },
  mounted () {
    if (this.$route.name === 'meetings.edit' || this.initDate) {
      this.day = moment(this.meeting.start_at)
    }
    this.fetchData()
    if (!this.initDate) this.selectDay(moment().date())
    this.$emit('closeModal')
    if (this.autoSetToday) this.setToday()
    this.selectedDay = moment(this.meeting.start_at)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Calendar.vue